import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useT } from "../../lib/i18n";
import PublicFrame, { usePublicBranding } from "./PublicFrame";

export default function PaymentResult({ cancelled }) {
  const [params] = useSearchParams();
  const { t } = useT();
  const [clinic, setClinic] = useState(null);
  const [state, setState] = useState(cancelled ? "failed" : "checking");
  const isOrder = sessionStorage.getItem("mcm_kind") === "order";
  const token = sessionStorage.getItem("mcm_manage");
  const slug = sessionStorage.getItem("mcm_slug");
  useEffect(() => { if (slug) api.get(`/public/c/${slug}/clinic`).then((r) => setClinic(r.data)); }, [slug]);
  usePublicBranding(clinic);

  useEffect(() => {
    if (cancelled) return;
    const sid = params.get("session_id");
    let tries = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch (e) { return setState("failed"); }
      if (++tries < 10) timer = setTimeout(poll, 2000); else setState("failed");
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, params]);

  return (
    <PublicFrame branding={clinic?.branding}>
      <div className="rounded-[var(--radius)] border bg-card p-10 text-center space-y-4" data-testid="payment-result">
        {state === "checking" && <><Loader2 className="h-10 w-10 mx-auto animate-spin text-primary" /><p data-testid="payment-checking">{t("checking_payment")}</p></>}
        {state === "paid" && <><CheckCircle2 className="h-12 w-12 mx-auto text-emerald-600" /><h1 className="text-2xl font-bold" data-testid="payment-success">{isOrder ? "Thank you, your order is confirmed" : t("booking_confirmed")}</h1>
          {isOrder && slug && <Link to={`/shop/${slug}`} className="text-primary underline" data-testid="payment-shop-link">Back to shop</Link>}
          {!isOrder && token && <Link to={`/manage/${token}`} className="text-primary underline" data-testid="payment-manage-link">{t("manage_booking")}</Link>}</>}
        {state === "failed" && <><XCircle className="h-12 w-12 mx-auto text-destructive" /><h1 className="text-2xl font-bold" data-testid="payment-failed">{t("payment_failed")}</h1>
          <Link to={`/book/${slug || ""}`} className="text-primary underline" data-testid="payment-retry-link">{t("book_title")}</Link></>}
      </div>
    </PublicFrame>
  );
}
